import InfoTip from './InfoTip.vue';

export default InfoTip;
